import { useState } from 'react'
import PropTypes from 'prop-types'

import { useAuthedFetch } from '../../../auth/useAuthedFetch'
import withFetchCancel from '../../../libs/withFetchCancel'
import useTranslations from '../../../i18n/useTranslations'
import { useUserContext } from '../../../auth/UserProvider'

import RatesView from './View'
import { generateCustomPDF } from './RatesReportPDF'

const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT

const propTypes = {
  clientCode: PropTypes.string,
}

const Rates = ({ clientCode }) => {
  const t = useTranslations()
  const authedFetch = useAuthedFetch()
  const user = useUserContext()

  const [loadingLastRate, setLoadingLastRate] = useState(false)

  const downloadAndOpenLastRate = async date => {
    setLoadingLastRate(true)

    try {
      const response = await withFetchCancel(signal =>
        authedFetch(
          'GET',
          `${BACKEND_ENDPOINT}/client/${clientCode}/rates?date=${date}`,
          {
            parseJSON: true,
            signal,
          },
        ),
      )

      if (response && response.data) {
        generateCustomPDF(response.data, t, user)
      }
    } catch (error) {
      console.error('Error al generar el PDF:', error)
    } finally {
      setLoadingLastRate(false)
    }
  }

  return (
    <RatesView
      loadingLastRate={loadingLastRate}
      openLastRate={date => downloadAndOpenLastRate(date)}
    />
  )
}

Rates.propTypes = propTypes

export default Rates
